(() => {
  function initHeader(header) {
    if (!header || header.dataset.polishReady) return;
    header.dataset.polishReady = 'true';
    const toggle = header.querySelector('[data-acqua-toggle]');
    const items = [...header.querySelectorAll('.acqua-item')];
    const desktop = window.matchMedia('(min-width:1200px)');
    header.querySelectorAll('.acqua-language-form').forEach(form => {
      form.addEventListener('submit', () => {
        let returnTo = form.querySelector('[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.append(returnTo);
        }
        returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      });
    });
    const setItem = (item, open) => {
      item.classList.toggle('is-expanded', open);
      item.querySelector('.acqua-submenu-toggle')?.setAttribute('aria-expanded', String(open));
    };
    const closeMenus = () => items.forEach(item => setItem(item, false));
    const closeHeader = () => {
      header.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      closeMenus();
    };
    toggle?.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      if (!open) closeMenus();
    });
    items.forEach(item => {
      const button = item.querySelector('.acqua-submenu-toggle');
      if (!button) return;
      button.addEventListener('click', event => {
        const open = desktop.matches && event.detail > 0 ? true : !item.classList.contains('is-expanded');
        closeMenus(); setItem(item, open);
      });
      item.addEventListener('pointerenter', event => {
        if (desktop.matches && event.pointerType !== 'touch') { closeMenus(); setItem(item, true); }
      });
      item.addEventListener('pointerleave', event => {
        if (desktop.matches && event.pointerType !== 'touch' && !item.contains(document.activeElement)) setItem(item, false);
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) setItem(item, false);
      });
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const current = items.find(item => item.classList.contains('is-expanded'));
      if (current) { setItem(current, false); current.querySelector('.acqua-submenu-toggle')?.focus(); }
      else { closeHeader(); toggle?.focus(); }
    });
    document.addEventListener('click', event => { if (!header.contains(event.target)) closeHeader(); });
    desktop.addEventListener('change', closeHeader);
  }
  document.querySelectorAll('[data-acqua-header]').forEach(initHeader);
  document.addEventListener('shopify:section:load', event => initHeader(event.target.querySelector('[data-acqua-header]')));
})();
